import { HolidaysCreateErrorBoundary } from '@/pages/time-off-holidays/admin-create/holidays-create.error';

export default HolidaysCreateErrorBoundary;
